export const friendsData = [
    {
        logo: './images/dark-matter.png',
        link: 'https://www.darkmattercoffee.com/',
        altText: "dark matter coffee logo"
    },
    {
        logo: './images/do-rite.png',
        link: 'https://www.doritedonuts.com/',
        altText: "do rite donuts logo"
    },
    {
        logo: './images/hewn-logo.png',
        link: 'https://www.hewnbread.com/',
        altText: "hewn bread"
    },
    {
        logo: './images/CatalpaGroveFarm.jpeg',
        link: 'http://www.catalpagrovefarm.com/',
        altText: "catalpa grove farm logo"
    },
    {
        logo: './images/volition.png',
        link: 'https://www.volitiontea.com/',
        altText: "volition tea logo"
    },
    
]